module.exports = __webpack_public_path__ + "img/south-of-the-border-taco-soup.a187b99f.jpg";